module.exports = __webpack_public_path__ + "static/media/grad01.9d20b4a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/subotica/grad01.jpg
// module id = 446
// module chunks = 0